
	export default {
		props: {
			keyId: {
				type: String|Number,
				required: true
			}
		},
		data(){
			return {
				educator: {},
				educator_id: this.keyId.substring(1),
				name: ``,
				loginModal: false,
				altTitle: `Guitar Lessons - TrueFire`,
				altDescription: `Learn how to play guitar with free online guitar lessons at TrueFire.`
			}
		},
	  computed: {
	    metaTitle() {
	      return this.name ? this.name + ` Online Guitar Lessons - TrueFire` : this.altTitle
	    },

	    metaDescription() {
	      return this.name ? `Learn how to play guitar with free online guitar lessons by ` + this.name + ` at TrueFire.` : this.altDescription
	    },
	    metaImage(){
	      return this.educator ? `https://df4emreqpcien.cloudfront.net/images/educators/'${this.educator.authorid}/169_1920.jpg?width=1296&format=webp` : false
	    }
	  },
		head() {
			return {
				title: this.metaTitle,
				meta: [
	        { hid: 'description', name: 'description', content: this.metaDescription },
	        { hid: 'robots', name: 'robots', content: 'index,follow' },
	        { hid: 'viewport', name: 'viewport', content: 'width=device-width, initial-scale=1' },
	        { hid: 'og:title', property: 'og:title', content: this.metaTitle },
	        { hid: 'og:description', property: 'og:description', content: this.metaDescription },
	        { hid: 'og:image', property: 'og:image', content: this.metaImage },
	        { hid: 'og:type', property: 'og:type', content: 'website' },
	        { hid: 'twitter:title', name: 'twitter:title', content: this.metaTitle },
	        { hid: 'twitter:description', name: 'twitter:description', content: this.metaDescription },
	        { hid: 'twitter:image', name: 'twitter:image', content: this.metaImage },
	        { hid: 'twitter:card', name: 'twitter:card', content: 'summary_large_image' },
	        { hid: 'twitter:site', name: 'twitter:site', content: '@TrueFire' }

				],
				link:[
					{ rel: 'canonical', href: this.educator && this.educator.canonical ? this.educator.canonical : "https://truefire.com/online-guitar-lessons" },
				],
			}
		},
		created(){
			if(process.client){
				if(location.href.includes('login=true')){
					this.loginModal = true
				}
			}
		},
		async fetch(){
			try {
				const educator = await this.$educator.get(this.keyId.substring(1),
					[
						'id',
						'authorid',
						'authorfirstname',
						'authorlastname',
						'authorinfo:clean',
						'product_types',
						// 'courses',
						'raves',
						'itjs',
						'channels',
						'classrooms',
						'jams',
						'yotpo',
						'private_lessons',
						'bandsintown',
						// 'spotlight',
						'mtk_premium',
						'canonical'
					]
				);
				console.log('heyyy', educator)
				this.educator = educator
				this.name = this.educator.authorfirstname && this.educator.authorlastname ? this.educator.authorfirstname + ` ` + this.educator.authorlastname : ``
			} catch(err){}
		}
	}

